import { ClientsState } from "@/modules/clients/clients.types";

export default {
  isClientDefault(state: ClientsState): boolean {
    return (
      state.data?.type == 0 ||
      state.data?.type == 2 ||
      state.data?.type == 5 ||
      false
    );
  },
  isClientDefaultNonTracker(state: ClientsState): boolean {
    return state.data?.type == 0 || false;
  },
  //Cargo Check
  isClientCC(state: ClientsState): boolean {
    return state.data?.type == 1 || false;
  },
  //Process Monitoring
  isClientPM(state: ClientsState): boolean {
    return state.data?.type == 2 || state.data?.type == 5 || false;
  },
  // Inventory Manager clients
  isClientIM(state: ClientsState): boolean {
    return state.data?.type == 3 || false;
  },
  //Asset Manager
  isClientAM(state: ClientsState): boolean {
    return state.data?.type == 4 || false;
  },
  //Clients with GPS map
  isClientGPS(state: ClientsState): boolean {
    return state.data?.type == 5 || false;
  },
  isClientTrackerNonGps(state: ClientsState): boolean {
    return state.data?.type == 2 || false;
  },
  isShowRssiClient(state: ClientsState): boolean {
    return state.data?.id === 63 || state.data?.id === 62 || false;
  }
};
